
export const uploadsUrl = process.env.CONTENT_URL || 'https://uploads.usad.hlxcongress.digital'
export const contentUrl = `${uploadsUrl}/content`
export const assetsUrl = `${uploadsUrl}/assets`
export const videoContentUrl = `${contentUrl}/videos`
export const pdfContentUrl = `${contentUrl}/pdfs`
export const pdfViewer = `${uploadsUrl}/pdf/web/viewer.html`
